import Modal from "@/components/Modal/Index.vue";
import ImgLazy from "@/components/ImgLazy/Index.vue";
import Loading from "@/components/Loading/loading.vue";
import Dropdown from "@/components/Dropdown.vue";

const plugins = {
  install(Vue) {
    Vue.component("AiModal", Modal);
    Vue.component("AiImgLazy", ImgLazy);
    Vue.component("LoadingCom", Loading);
    Vue.component("AiDropdown", Dropdown);
  },
};
export default plugins;
